import React, { Component } from "react";
import Wrapper from "../../../../_hoc/Wrapper";
import SimpleList from "../../../UI/SimpleList";

const simpleListItem = [
  {
    text: ({ status }) => (
      <Wrapper>
        {status.pendingConnect ? (
          <Wrapper>
            <i className="fa fa-envelope" />
            Cancel Request To Connect
          </Wrapper>
        ) : status.requestedToConnect ? (
          <Wrapper>
            <i className="fa fa-check" />
            Accept Request For Connect
          </Wrapper>
        ) : status.connected ? (
          <Wrapper>
            <i className="fa fa-times-rectangle-o" />
            Disconnect
          </Wrapper>
        ) : (
          <Wrapper>
            <i className="fa fa-heartbeat" />
            Connect
          </Wrapper>
        )}
      </Wrapper>
    ),
    onClick: component => {
      component.connect();
    }
  },
  {
    text: ({ status }) => (
      <Wrapper>
        {status.like ? (
          <Wrapper>
            <i className="fa fa-thumbs-down" />
            Unlike Profile
          </Wrapper>
        ) : (
          <Wrapper>
            <i className="fa fa-thumbs-up" />
            Like Profile
          </Wrapper>
        )}
      </Wrapper>
    ),
    onClick: component => {
      component.like();
    }
  },
  {
    text: ({ status }) => (
      <Wrapper>
        {status.interest ? (
          <Wrapper>
            <i className="fa fa-heart-o" />
            Cancel Interest
          </Wrapper>
        ) : (
          <Wrapper>
            <i className="fa fa-heart" />
            Express Interest
          </Wrapper>
        )}
      </Wrapper>
    ),
    onClick: component => {
      component.showInterest();
    }
  },
  {
    text: ({ status }) => (
      <Wrapper>
        {status.shortlist ? (
          <Wrapper>
            <i className="fa fa-bookmark-o" />
            Remove From Shortlist
          </Wrapper>
        ) : (
          <Wrapper>
            <i className="fa fa-bookmark" />
            Shortlist Profile
          </Wrapper>
        )}
      </Wrapper>
    ),
    onClick: component => {
      component.shortlist();
    }
  },
  {
    text: ({ status }) => (
      <Wrapper>
        {status.favorite ? (
          <Wrapper>
            <i className="fa fa-times-rectangle-o" />
            Remove From Favorite
          </Wrapper>
        ) : (
          <Wrapper>
            <i className="fa fa-anchor" />
            Add To Favourite
          </Wrapper>
        )}
      </Wrapper>
    ),
    onClick: component => {
      component.addToFavorite();
    }
  },
  {
    text: ({ status }) => (
      <Wrapper>
        {status.save ? (
          <Wrapper>
            <i className="fa fa-times-rectangle-o" />
            Remove From Saved
          </Wrapper>
        ) : (
          <Wrapper>
            <i className="fa fa-save" />
            Save Profile
          </Wrapper>
        )}
      </Wrapper>
    ),
    onClick: component => {
      component.save();
    }
  }
];
export default class ProfileActions extends Component {
  like = () => {
    const { likeProfile } = this.props;
    likeProfile();
  };
  showInterest = () => {
    const { expressInterest } = this.props;
    expressInterest();
  };
  shortlist = () => {
    const { shortlist } = this.props;
    shortlist();
  };
  save = () => {
    const { saveProfile } = this.props;
    saveProfile();
  };
  addToFavorite = () => {
    const { addToFavorite } = this.props;
    addToFavorite();
  };
  connect = () => {
    const { connectToProfile } = this.props;
    connectToProfile();
  };
  render() {
    return <SimpleList items={simpleListItem} component={this} hover />;
  }
}



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Profile/ProfileActions/index.js